var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9 2.16675H6.27499C3.39165 2.16675 1.67499 3.88341 1.67499 6.76675V13.3917C1.67499 16.2751 3.39999 17.9917 6.27499 17.9917H12.9C15.7833 17.9917 17.5 16.2751 17.5 13.3917V6.76675C17.5 3.88341 15.775 2.16675 12.9 2.16675Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9 2.16675H6.27499C3.39165 2.16675 1.67499 3.88341 1.67499 6.76675V13.3917C1.67499 16.2751 3.39999 17.9917 6.27499 17.9917H12.9C15.7833 17.9917 17.5 16.2751 17.5 13.3917V6.76675C17.5 3.88341 15.775 2.16675 12.9 2.16675Z",
    fill: "#979797"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2293_111157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 14.583C15.4784 14.583 16.0171 14.3599 16.4143 13.9627C16.8115 13.5655 17.0346 13.0268 17.0346 12.4651C17.0346 11.9034 16.8115 11.3647 16.4143 10.9675C16.0171 10.5703 15.4784 10.3472 14.9167 10.3472C14.355 10.3472 13.8163 10.5703 13.4191 10.9675C13.0219 11.3647 12.7988 11.9034 12.7988 12.4651C12.7988 13.0268 13.0219 13.5655 13.4191 13.9627C13.8163 14.3599 14.355 14.583 14.9167 14.583ZM14.9167 15.642C12.7946 15.642 11.0663 17.0652 11.0663 18.8188C11.0663 18.9375 11.1595 19.0306 11.2781 19.0306H18.5553C18.6739 19.0306 18.7671 18.9375 18.7671 18.8188C18.7671 17.0652 17.0389 15.642 14.9167 15.642Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_111157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.166,
    height: 10.166,
    fill: "white",
    transform: "translate(9.83398 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/station.e8f5250d15129fa114f88bfd72c567b3.svg";
export { ForwardRef as ReactComponent };